export function requestHeaders(){
    return {
        'Authorization': "Bearer " + localStorage.getItem('token'),
        'source': localStorage.getItem('source'),
        'Content-Type': 'application/json'
    };
}

export function showLoader(){
    var fadeTarget = document.getElementById("h-page-loading");
    var fadeEffect = setInterval(function () {
        if (!fadeTarget.style.opacity) {
            fadeTarget.style.opacity = 0;
        }
        if (fadeTarget.style.opacity == 0) {
            fadeTarget.style.opacity = 0.7;
        } else {
            clearInterval(fadeEffect);
            fadeTarget.style.display = "block";
        }
    }, 100);
}
export function hideLoader(){
    var fadeTarget = document.getElementById("h-page-loading");
    var fadeEffect = setInterval(function () {
        if (!fadeTarget.style.opacity) {
            fadeTarget.style.opacity = 1;
        }
        if (fadeTarget.style.opacity > 0) {
            fadeTarget.style.opacity -= 0.1;
        } else {
            clearInterval(fadeEffect);
            fadeTarget.style.display = "none";
        }
    }, 100);
}